import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tick: [],
  stat: []
};

const statSlice = createSlice({
  name: 'stat',
  initialState,
  reducers: {
    setStat(state, action) {
      state.stat = action.payload.stat
      state.tick = action.payload.tick
    },
    setTick(state, action) {
      state.tick = { ...state.tick, ...action.payload }
    }
  }
});

export const { setStat, setTick } = statSlice.actions;

const statReducer = statSlice.reducer;
export default statReducer;
